import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ServerProvider} from "../../providers/server/server";

/**
 * Generated class for the AttemptPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'attempt',
  segment: 'cases/:caseId/:attempt'
})
@Component({
  selector: 'page-attempt',
  templateUrl: 'attempt.html',
})
export class AttemptPage {
  form = {
    caseId: 0, locationType: 0, addressSelect: 0, location: '', businessName: '',
    noteLeft: '', signature: false, type: '', details: '', comments: '',
    race: '', age: '', weight: '', height: '', sex: '', hair: '', latitude: '', longitude: '', photo: '',
    address: '', address2: '', city: '', state: '', zip: '', status: 0
  }
  caseId;
  attempt;
  options;
  addresses;
  case;
  location;

  constructor(public loadingCtrl: LoadingController, public alertCtrl: AlertController, public server: ServerProvider, public navCtrl: NavController, public navParams: NavParams) {
    this.caseId = navParams.get('caseId');
    this.attempt = navParams.get('attempt');
    this.server.get('options' ).subscribe( (data:any)=>{
      console.log('Getting options...', data);
      this.options = data.data;
    });
    this.server.get('cases', this.caseId ).subscribe( (data:any)=>{
      console.log('Getting case...', data);
      this.addresses = [];
      this.case  = data.data;
      if( data.data.address ) this.addresses.push({ label: data.data.address, value: 0, address: data.data });
      if( data.data.secondAddress ) this.addresses.push({ label: data.data.secondAddress, value: 1, address: data.data });
      if( data.data.employment ) this.addresses.push({ label: data.data.employment, value: 2, address: data.data });
    });

    if( navigator.geolocation ){
      navigator.geolocation.getCurrentPosition( data=>{
        console.log( data );
        this.location = data.coords;
        this.form.latitude = this.location.latitude;
        this.form.longitude = this.location.longitude;
      });
    };
  }

  status() {
    switch (this.attempt) {
      case 'skip':
        return 0;
      case 'noContact':
        return 1;
      case 'serve':
        return 2;
      case 'other':
      default:
        return 3;
    }
  }

  getLocation(){
    switch (this.form.location) {
      case 'apartment':
        return 'Apartment';
      case 'singleFamilyHome':
        return 'Single Family Home';
      case 'business':
        return 'Business';
    }
    return '';
  }

  submit(){
    let loading = this.loadingCtrl.create();
    loading.present();
    this.form.caseId = this.caseId;
    this.form.status = this.status();

    if( this.status() == 1 ){
      this.form.details = this.getLocation() + ' - ' + this.form.details;
    } else {
      this.form.details = this.form.type + ' - ' + this.form.details;
    }

    if( this.status() != 3 ) {
      this.form.noteLeft = (this.form.noteLeft ) ? 'YES' : 'NO';
      if (this.form.addressSelect == 0) {
        this.form.address = this.case.address;
        this.form.address2 = this.case.address2;
        this.form.city = this.case.city;
        this.form.state = this.case.state;
        this.form.zip = this.case.zip;
      }
      if (this.form.addressSelect == 1) {
        this.form.address = this.case.secondAddress;
        this.form.address2 = this.case.secondAddress2;
        this.form.city = this.case.secondCity;
        this.form.state = this.case.secondState;
        this.form.zip = this.case.secondZip;
      }
      if (this.form.addressSelect == 2) {
        this.form.businessName = this.case.employment;
        this.form.address = this.case.employmentAddress;
        this.form.address2 = this.case.employmentAddress2;
        this.form.city = this.case.employmentCity;
        this.form.state = this.case.employmentState;
        this.form.zip = this.case.employmentZip;
      }
    }

    this.server.post( 'notes', this.form, this.caseId+'/notes' ).subscribe( data=>{
      loading.dismiss();
      let alert = this.alertCtrl.create({
        title: "Success",
        message: "Your information was submitted successfully!",
        buttons: [
          { text: "Ok" }
        ]
      });
      alert.onDidDismiss(()=>{
        this.navCtrl.pop();
      });
      alert.present();
    });
  }

  photo(event){
    event.preventDefault();
    let files;
    if( event.dataTransfer && event.dataTransfer.files )
      files = event.dataTransfer.files;
    else if( event.target && event.target.files )
      files = event.target.files;
    else return false;

    if( files.length > 0 ){
       let file = files[0];
        if (file.type.match(/image.*/)) {
          this.server.resizeImage( file, 2000, dataUrl=>{
            this.form.photo = dataUrl;
          });
        } else {
          alert('Photo upload error #1');
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/attempt/attempt.ts